<script lang="ts">
  interface Props {
    label?: string;
    top?: boolean;
    right?: boolean;
    bottom?: boolean;
    left?: boolean;
    children?: import('svelte').Snippet;
  }

  let {
    label = '',
    top = false,
    right = false,
    bottom = false,
    left = false,
    children
  }: Props = $props();
</script>

<div class="comp-tooltip">
  <span class="tooltip-component">
    {@render children?.()}
  </span>
  <div class="tooltip-popup" class:left class:right class:bottom class:top>
    {#if label}
      <div class="default-tip">{label}</div>
    {/if}
  </div>
</div>

<style>
  .comp-tooltip {
    position: relative;
    display: inline-block;
  }
  .tooltip-popup {
    min-width: 80px;
    width: max-content;
    color: #585c64;
    text-align: center;
    border-radius: 3px;
    position: absolute;
    box-shadow: 0 4px 18px 3px rgb(0 0 0 / 10%), 0 3px 11px 1px rgb(0 0 0 / 8%);
    border: solid 1 px #e5e5e5;
    background: white;
    visibility: hidden;
  }
  .tooltip-popup::after {
    content: '';
    position: absolute;
    border-width: 5px;
    border-style: solid;
    border-color: white;
  }

  .default-tip {
    display: inline-block;
    padding: 4px;
    color: inherit;
  }

  .tooltip-popup.top {
    left: 50%;
    bottom: 25%;
    transform: translate(-50%, -100%);
  }
  .tooltip-popup.top::after {
    top: 100%;
    left: 50%;
    transform: translate(-50%, -50%) rotate(45deg);
  }

  .tooltip-popup.bottom {
    left: 50%;
    bottom: -50%;
    transform: translate(-50%, 100%);
  }
  .tooltip-popup.bottom::after {
    left: 50%;
    transform: translate(-5px, -50%) rotate(-140deg);
  }

  .tooltip-popup.left {
    left: -15px;
    bottom: 0;
    transform: translateX(-100%);
  }
  .tooltip-popup.left::after {
    right: -5px;
    top: 50%;
    transform: translate(0, -50%) rotate(-45deg);
  }
  .tooltip-popup.right {
    right: -15px;
    bottom: 0;
    transform: translateX(100%);
  }
  .tooltip-popup.right::after {
    top: 50%;
    right: 94%;
    transform: translate(0, -50%) rotate(140deg);
  }

  .tooltip-component:hover + .tooltip-popup {
    visibility: visible;
  }
</style>
